// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import { PriorityReservationInquiryTable, RegionPriorityReservationInquiryTable } from './components/priority-reservation-inquiry-table';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { getFamiliesFromRegion, getPriorityReservationInquiry } from './repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getRegions } from '../../common/repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class PriorityReservationInquiry extends Component {

    state = {
        regions: [],
        familyTypes: [],
        selectedRegion: '',
        selectedFamilyType: '',
        priorityReservationInquiryResults: [],
        regionPriorityReservationInquiryResult: []
    };

    componentDidMount = () => {

        this.props.increaseCounter();
        getRegions().then( response => {

            this.setState( {
                regions: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleRegionChange ( val ) {

        this.setState( {
            selectedRegion: val
        }, () => {

            this.props.increaseCounter();
            getFamiliesFromRegion( val ).then( response => {

                this.setState( {
                    familyTypes: response,
                    selectedFamilyType: ''
                } );
                this.props.decreaseCounter();
                this.refresh();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        } );

    }

    handleFamilyChange ( val ) {

        this.setState( {
            selectedFamilyType: val
        }, () => {

            this.refresh();

        } );

    }

    refresh () {

        if ( this.state.selectedFamilyType && this.state.selectedRegion ) {

            this.props.increaseCounter();
            const { selectedFamilyType } = this.state;
            const { selectedRegion } = this.state;
            getPriorityReservationInquiry( selectedRegion, selectedFamilyType )
                .then( response => {

                    let tableResult = [];
                    tableResult.push( response );

                    this.setState( {
                        priorityReservationInquiryResults: tableResult
                    } );

                    tableResult = [];

                    response.regionals.forEach( tempResult => {

                        tableResult.push( tempResult );

                    } );
                    this.setState( {

                        regionPriorityReservationInquiryResult: response.regionals
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

        }

    }

    render () {

        const {
            regions, familyTypes, selectedRegion, selectedFamilyType,
            priorityReservationInquiryResults, regionPriorityReservationInquiryResult
        } = this.state;

        const additionalInfo = { unitName: this.props.unit.name };
        const priorityReservationInquiryResultsVal = priorityReservationInquiryResults
            .map( i => ( { ...i, ...additionalInfo } ) );

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">Priority Reservation Inquiry</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-priority-reservation-inquiry-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-priority-reservation-inquiry-select"
                                    label="Region"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleRegionChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={regions}
                                    placeholder="Select Region"
                                    selectedValue={selectedRegion}
                                />

                                {selectedRegion && (
                                    <OptionsDropDown
                                        className="atp-priority-reservation-inquiry-select"
                                        label="Family"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleFamilyChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={familyTypes}
                                        placeholder="Select Family"
                                        selectedValue={selectedFamilyType}
                                    />
                                )}

                                {selectedRegion && selectedFamilyType && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}

                            </div>
                        </div>
                        {selectedRegion && selectedFamilyType && (
                            <PriorityReservationInquiryTable
                                results={priorityReservationInquiryResultsVal}
                            />
                        )}
                        {selectedRegion && selectedFamilyType && (
                            <RegionPriorityReservationInquiryTable
                                results={regionPriorityReservationInquiryResult}
                            />
                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

PriorityReservationInquiry.displayName = 'PriorityReservationInquiry';
PriorityReservationInquiry.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( PriorityReservationInquiry ) );
